module.exports = __webpack_public_path__ + "static/img/hb_41-min.164fccd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_41-min.png
// module id = C7tH
// module chunks = 1